import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-690978a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-3"
}
const _hoisted_3 = { class: "lg:col-span-1 col-span-3 flex flex-col gap-4 lg:border-r border-b" }
const _hoisted_4 = { class: "px-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Periodos de dividendos", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Ingrese las fechas en las que se realizarán pagos de dividendos. Las fechas ingresadas se muestran abajo como lista horizontal. ", -1))
const _hoisted_7 = { class: "lg:col-span-2 col-span-3 flex flex-col justify-items-center" }
const _hoisted_8 = { class: "flex flex-col gap-2 p-4" }
const _hoisted_9 = { class: "subsection" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4" }, "Parámetros escalares", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4" }, "Condiciones de accionista", -1))
const _hoisted_12 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_13 = { class: "lg:col-span-1 col-span-3 flex flex-col gap-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Indique los limites de los accionistas", -1))
const _hoisted_15 = { class: "lg:col-span-1 col-span-3 flex flex-col gap-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Indique el mínimo de meses", -1))
const _hoisted_17 = { class: "subsection flex flex-col gap-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-bold" }, "Acciones emitidas", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Establezca las acciones emitidas para cada uno de las series de acciones. Esto se usará como métrica y limite para la venta de acciones de Rentas Dhelos. ", -1))
const _hoisted_20 = { class: "flex flex-col lg:flex-row gap-4" }
const _hoisted_21 = { class: "subsection self-end" }
const _hoisted_22 = ["disabled"]

import { computed, ref } from "vue";
import { ParameterService } from "@/services/parameters/parameterService";
import { Parameter } from "@/services/parameters/typer";

import TextField from "@/components/atoms/TextField.vue";
import InputChip from "@/components/molecules/DateInputChip.vue";
import ComponentCard from "@/components/atoms/ComponentCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ParamsView',
  setup(__props) {

const parameters = ref<null | Parameter>(null);
const parameterService = new ParameterService();

const dividendPaymentPeriodAux = ref<null | string[]>(null);
const stockSalesWinAux = ref<null | string[][]>(null);
const changed = ref<boolean>(false);

//* ----- Geting Parameters------

(async () => {
  let response = await parameterService.getParameters();
  if (!response.success) {
    console.log(
      "Ha ocurrido un error al intentar obtener la tarjeta de presentación del accionista"
    );
    return;
  }

  parameters.value = response.data;
  dividendPaymentPeriodAux.value = parameters.value.dividendPaymentPeriod;
  stockSalesWinAux.value = parameters.value.stockSaleWindows;
})();

const submitForm = async () => {
  let body = { ...parameters.value };
  if (dividendPaymentPeriodAux.value && stockSalesWinAux.value) {
    body.dividendPaymentPeriod = dividendPaymentPeriodAux.value;
    body.stockSaleWindows = stockSalesWinAux.value;
  }
  if (body) {
    let response = await parameterService.editParameters(body);
    changed.value = false;
    if (response) alert("Se han guardado los cambios exitosamente");
    return response;
  }
};
//* ----- dividendPaymentPeriod Functions ------
//* ----- -----------------------
const dropDate = (itemIndex: number) => {
  if (dividendPaymentPeriodAux.value) {
    dividendPaymentPeriodAux.value = dividendPaymentPeriodAux.value?.filter(
      (item, index) => {
        return index !== itemIndex;
      }
    );
  }
  changed.value = true;
};
const addDate = (item: string) => {
  dividendPaymentPeriodAux.value?.push(item);
};
//* ----- stockSaleWindows Functions ------
//* ----- -----------------------
const dropDateWin = (itemIndex: number) => {
  if (stockSalesWinAux.value) {
    stockSalesWinAux.value = stockSalesWinAux.value?.filter((item, index) => {
      return index !== itemIndex;
    });
  }
  changed.value = true;
};
const addDateWin = (item: string[]) => {
  stockSalesWinAux.value?.push(item);
  changed.value = true;
};
const editDateWin = (item: string[], index: number) => {
  stockSalesWinAux.value?.splice(index, 1, item);
  changed.value = true;
};

//* ----- Error Management ------
//* ----- -----------------------
const minMonthToSellError = computed(() => {
  return isNullOrEmpty(parameters.value?.minMonhtsToSellShares);
});
const ufPriceError = computed(() => {
  return isNullOrEmpty(parameters.value?.ufSharesPrice);
});
const minSharesError = computed(() => {
  return isNullOrEmpty(parameters.value?.minShares);
});

function isNullOrEmpty(value?: string | number | null): boolean {
  return !value || value == null || value == "" || value == 0;
}

const formHasError = computed(() => {
  const requiredFields = [
    parameters.value?.minMonhtsToSellShares,
    parameters.value?.ufSharesPrice,
    parameters.value?.minShares,
  ];
  if (requiredFields.some((value) => isNullOrEmpty(value))) {
    return true;
  }
  const formErrors = [
    minMonthToSellError.value,
    ufPriceError.value,
    minSharesError.value,
  ];
  if (formErrors.some((hasError) => hasError == true)) {
    return true;
  }
  return false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComponentCard, { title: "" }, {
      default: _withCtx(() => [
        (parameters.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _hoisted_6,
                  _createVNode(InputChip, {
                    array: dividendPaymentPeriodAux.value,
                    onDrop: dropDate,
                    onAdd: addDate
                  }, null, 8, ["array"])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(TextField, {
                          model: parameters.value.minShares,
                          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((parameters.value.minShares) = $event)),
                          class: "flex-1",
                          type: "number",
                          name: "minShares",
                          label: "Mínimo de acciones",
                          "hide-details": "",
                          "hide-info": "",
                          "info-message": "El mínimo de acciones corresponde a la cantidad mínima que\n                      un accionista debe poseer. Si un accionista intenta vender\n                      una cantidad de acciones que lo dejen por debajo de estas\n                      cantidad mínima, el sistema rechazará la operación.",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (changed.value = true))
                        }, null, 8, ["model"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(TextField, {
                          model: parameters.value.minMonhtsToSellShares,
                          "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((parameters.value.minMonhtsToSellShares) = $event)),
                          class: "flex-1",
                          type: "number",
                          name: "minMonthsSellShares",
                          label: "Minimo de meses",
                          "hide-details": "",
                          "hide-info": "",
                          "info-message": "Los meses mínimos indica la cantidad de meses que deben transcurrir para que un accionista pueda realizar operaciones de venta de acciones.",
                          "has-error": minMonthToSellError.value,
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (changed.value = true))
                        }, null, 8, ["model", "has-error"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(TextField, {
                        model: parameters.value.totalSharesGroupA,
                        "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((parameters.value.totalSharesGroupA) = $event)),
                        class: "flex-1",
                        label: "Acciones serie A",
                        name: "totalSharesGroupA",
                        type: "number",
                        "hide-details": "",
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (changed.value = true))
                      }, null, 8, ["model"]),
                      _createVNode(TextField, {
                        model: parameters.value.totalSharesGroupB,
                        "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((parameters.value.totalSharesGroupB) = $event)),
                        class: "flex-1",
                        label: "Acciones serie B",
                        name: "totalSharesGroupB",
                        type: "number",
                        "hide-details": "",
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (changed.value = true))
                      }, null, 8, ["model"]),
                      _createVNode(TextField, {
                        model: parameters.value.ufSharesPrice,
                        "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((parameters.value.ufSharesPrice) = $event)),
                        class: "flex-1",
                        type: "number",
                        name: "ufSharesPrice",
                        label: "Precio de una acción en UF",
                        "hide-details": "",
                        "error-message": "El campo es requerido",
                        "has-error": ufPriceError.value,
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (changed.value = true))
                      }, null, 8, ["model", "has-error"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "success btn w-36 ml-auto",
                      onClick: submitForm,
                      disabled: !changed.value
                    }, " Guardar ", 8, _hoisted_22)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})